import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['accept', 'checkbox', 'warning'];

  validate() {
    this.hasCheckboxTarget && this.checkboxTarget.classList.toggle('notice-danger', !this.acceptTarget?.checked);
    this.hasWarningTarget && this.warningTarget.classList.toggle('invisible', this.acceptTarget?.checked);
  }

  submit(event) {
    if (!this.acceptTarget?.checked) {
      event.preventDefault();
      event.stopPropagation();
      this.hasWarningTarget && this.warningTarget.classList.remove('invisible');

      if (this.hasCheckboxTarget) {
        this.checkboxTarget.classList.add('notice-danger');
        this.checkboxTarget.scrollIntoView();
      }

      return;
    }

    this.element.requestSubmit();
  }
}
